import { getToken, clearSession, isSessionValid } from "./sessionManager";
import WebSocketManager from "../ws/client";

export function getAuthToken() {
  return getToken();
}

export function logout() {
  WebSocketManager.disconnect();
  clearSession();
  redirectToLogin();
}

export function redirectToLogin() {
  if (window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
}

export function ensureValidSession() {
  if (!isSessionValid()) {
    logout();
    return false;
  }
  return true;
}